<template>


    <div class="row justify-content-center">
        <div class="col-md-10 ">
                <table class="table table-bordered">

                  <tbody>
                            <tr v-for="fichero in ficheros" :key="fichero.uuid">

                        <td width="10%">
                          <h1>
                            <a v-bind:href="fichero.original_url" target="_blank" >
                                            <div v-if="fichero.extension==='pdf'">
                                              <i class="fa fa-file-pdf" aria-hidden="true"></i>
                                            </div>
                                              <div v-else-if="fichero.extension==='jpg'">
                                                <i class="fa fa-file-image" aria-hidden="true"></i>
                                            </div>
                                            <div v-else-if="fichero.extension==='png'">
                                            <i class="fa fa-file-image" aria-hidden="true"></i>
                                            </div>
                                            <div v-else-if="fichero.extension==='gif'">
                                                    <i class="fa fa-file-image" aria-hidden="true"></i>
                                            </div>
                                            <div v-else>
                                                <i class="fa fa-file" aria-hidden="true"></i>
                                             </div>
                                            </a>
                            </h1>
                        </td>
                      <td width="80%">
                        <a v-bind:href="fichero.original_url" target="_blank" > {{ fichero.file_name}}</a>
                      </td >
                                            <td  width="10%" > <button class="btn btn-danger" @click="borraFichero(fichero.uuid)">  <span class="fa fa-trash" aria-hidden="true"></span></button>
                      </td>
                    </tr>

                    </tbody>
                </table>
              </div>
            </div>
















</template>


<script>
import { throwStatement } from '@babel/types';


export default {
    props: ["documento"],
    data() {
      return {
        codigo: "",
        ficheros: [],
        confirmacion:0,

      };
    },

    methods: {


      getListaFicheros: function () {
                axios.get("/documentos/upload/listar_ficheros/" +this.codigo
        )
        .then(
          function (response) {
            this.ficheros = response.data.ficheros_documento;




          }.bind(this)
        );
      },

      borraFichero: function (uuid) {
        this.confirmacion=confirm('Confirmar eliminación');

            if (this.confirmacion==1) {
                axios.delete("/documentos/borrar_fichero/" +this.codigo+"/"+uuid)
                    .then(response => {
                        this.getListaFicheros();
                    });

          }

      }


    },






    mounted() {
      this.codigo = this.documento.codigo;
      this.getListaFicheros();
    },



  };
  </script>



